import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Min ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Max ")
const _hoisted_3 = { class: "container-column" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_6 = { class: "container-column" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_9 = {
  key: 1,
  class: "container"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_i18n_number = _resolveComponent("i18n-number")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_scale_tare_item = _resolveComponent("scale-tare-item")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createBlock(_component_ion_card, { color: "light" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_card_content, null, {
        default: _withCtx(() => [
          (!_ctx.scale_metrics)
            ? (_openBlock(), _createBlock(_component_ion_grid, {
                key: 0,
                class: "no-padding"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, { size: "4" }),
                      _createVNode(_component_ion_col, {
                        size: "4",
                        class: "ion-text-center"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_ion_col, {
                        size: "4",
                        class: "ion-text-center"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }),
                  (_ctx.metrics)
                    ? (_openBlock(), _createBlock(_component_ion_row, {
                        key: 0,
                        class: "ion-align-items-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { size: "4" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_ion_icon, {
                                  src: "assets/mdt-italia/002_bsentinel.svg",
                                  class: "custom_icon",
                                  color: "primary"
                                }),
                                _createVNode(_component_ion_text, {
                                  color: "primary",
                                  class: "peripheral-sku"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.i18n('details_internal_metrics')), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ])
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_ion_col, {
                            size: "4",
                            class: "ion-text-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_i18n_number, {
                                value: _ctx.metrics.temperature_min,
                                fraction: 2,
                                symbol: "°C"
                              }, null, 8 /* PROPS */, ["value"]),
                              _hoisted_4,
                              _createVNode(_component_i18n_number, {
                                value: _ctx.metrics.humidity_min,
                                symbol: "%"
                              }, null, 8 /* PROPS */, ["value"])
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_ion_col, {
                            size: "4",
                            class: "ion-text-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_i18n_number, {
                                value: _ctx.metrics.temperature_max,
                                fraction: 2,
                                symbol: "°C"
                              }, null, 8 /* PROPS */, ["value"]),
                              _hoisted_5,
                              _createVNode(_component_i18n_number, {
                                value: _ctx.metrics.humidity_max,
                                symbol: "%"
                              }, null, 8 /* PROPS */, ["value"])
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true),
                  (_ctx.meteo_metrics)
                    ? (_openBlock(), _createBlock(_component_ion_row, {
                        key: 1,
                        class: "ion-align-items-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { size: "4" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_6, [
                                _createVNode(_component_ion_icon, {
                                  src: "assets/mdt-italia/004_bmeteo.svg",
                                  class: "custom_icon",
                                  color: "primary"
                                }),
                                _createVNode(_component_ion_text, {
                                  color: "primary",
                                  class: "peripheral-sku"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.i18n('details_external_metrics')), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ])
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_ion_col, {
                            size: "4",
                            class: "ion-text-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_i18n_number, {
                                value: _ctx.meteo_metrics.temperature_min,
                                fraction: 2,
                                symbol: "°C"
                              }, null, 8 /* PROPS */, ["value"]),
                              _hoisted_7,
                              _createVNode(_component_i18n_number, {
                                value: _ctx.meteo_metrics.humidity_min,
                                symbol: "%"
                              }, null, 8 /* PROPS */, ["value"])
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_ion_col, {
                            size: "4",
                            class: "ion-text-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_i18n_number, {
                                value: _ctx.meteo_metrics.temperature_max,
                                fraction: 2,
                                symbol: "°C"
                              }, null, 8 /* PROPS */, ["value"]),
                              _hoisted_8,
                              _createVNode(_component_i18n_number, {
                                value: _ctx.meteo_metrics.humidity_max,
                                symbol: "%"
                              }, null, 8 /* PROPS */, ["value"])
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          (_ctx.scale_metrics)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (!_ctx.scale_metrics_validity)
                  ? (_openBlock(), _createBlock(_component_ion_label, {
                      key: 0,
                      color: "danger"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.i18n("details_scale_missing_metrics")), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true),
                (_ctx.scale_metrics_validity)
                  ? (_openBlock(), _createBlock(_component_ion_grid, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_col, {
                              size: "4",
                              class: "ion-text-start"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { color: "primary" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.i18n("details_scale_operations")), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_ion_col, {
                              size: "2",
                              class: "ion-text-end"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { color: "primary" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.i18n("details_scale_hour_of_day")), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_ion_col, {
                              size: "3",
                              class: "ion-text-end"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { color: "primary" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.i18n("details_scale_total_weight")), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_ion_col, {
                              size: "3",
                              class: "ion-text-end"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { color: "primary" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.i18n("details_scale_variation")), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }),
                        (_ctx.scale_metrics.weight_daily.hours)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.scale_metrics.weight_daily.hours, (item) => {
                              return (_openBlock(), _createBlock(_component_ion_row, {
                                class: "ion-justify-content-end",
                                item: item,
                                key: item.hour
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_col, { class: "ion-text-start" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.formatShortDate(_ctx.scale_metrics.weight_daily.latest )), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                  }),
                                  _createVNode(_component_ion_col, { class: "ion-text-end" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.hour) + ":00 ", 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */),
                                  _createVNode(_component_ion_col, { class: "ion-text-end" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_i18n_number, {
                                        value: item.value,
                                        fraction: 3
                                      }, null, 8 /* PROPS */, ["value"])
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */),
                                  _createVNode(_component_ion_col, { class: "ion-text-end" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_i18n_number, {
                                        value: item.diff,
                                        fraction: 3,
                                        signed: true
                                      }, null, 8 /* PROPS */, ["value"])
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["item"]))
                            }), 128 /* KEYED_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        _hoisted_10,
                        _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_col, {
                              size: "6",
                              class: "ion-text-start"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { color: "primary" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.i18n("details_scale_end_of_day")), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_ion_col, {
                              size: "3",
                              class: "ion-text-end"
                            }),
                            _createVNode(_component_ion_col, {
                              size: "3",
                              class: "ion-text-end"
                            })
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_col, {
                              size: "6",
                              class: "ion-text-start"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.formatShortDate(_ctx.scale_metrics.weight_daily.day_before)), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_ion_col, {
                              size: "3",
                              class: "ion-text-end"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_i18n_number, {
                                  value: _ctx.scale_metrics.weight_daily.net_weight_day_before,
                                  fraction: 3
                                }, null, 8 /* PROPS */, ["value"])
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_ion_col, {
                              size: "3",
                              class: "ion-text-end"
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          (_openBlock(), _createBlock(_component_scale_tare_item, {
            item: _ctx.item,
            key: _ctx.item
          }, null, 8 /* PROPS */, ["item"]))
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}